import * as dat from 'dat.gui';
require('./style.scss');

export const gui = ({name, config}) => {
    const gui = new dat.GUI()
    const data3D = gui.addFolder(name)
    const params = {};
    const conf = {};

    for(let i in config) {
        params[i] = config[i].value;
        conf[i] = config[i];
    }

    for(let i in params) {
        const {min, value, step, onChange, max} = conf[i];
        data3D.add(params, i, min, max, step).onChange(onChange);
    }
    
    gui.open();
    gui.show();
}